import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA0S6kcAVaDQ5CHSwTj53cPIimnzX0VqOk",
  authDomain: "biddify-co.firebaseapp.com",
  projectId: "biddify-co",
  storageBucket: "biddify-co.appspot.com",
  messagingSenderId: "590608362082",
  appId: "1:590608362082:web:3dfa902114c345eb4c7f3b",
  measurementId: "G-C7QHJWRHZ5",
};

export const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
